import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { DeliveryShipmentAction } from '../../../models/shipments/shipment-action';
import { TransportationSvc } from '../../../service';
import { OrderSearchFilters } from '../../../models/filters/order-search-filters';
import { ShipmentMethod } from '../../../models/enums/shipment-method';
import { OrderSummary } from '../../../models/shared/order-summary';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { useDispatch } from 'react-redux';
import ShipmentActionAddOrderRow from '../ShipmentActionAddOrderRow';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';

interface IProps {
    visible: boolean;
    onClose: any;
    onSuccess: any;
    truckId: number;
    truckVersion: string;
    stop: DeliveryShipmentAction | undefined;
}

let IGNORE_UNMOUNT_SELECTABLE = false;

export const ActionAddBackorder = (props: IProps) => {

    const dispatch = useDispatch();
    const [service] = React.useState(new TransportationSvc());
    const [filterParams] = React.useState(new OrderSearchFilters(ShipmentMethod.Delivery));
    const [availableOrders, setAvailableOrders] = React.useState<PagedApiResult<OrderSummary>>(() => {
        const initial = new PagedApiResult<OrderSummary>();
        initial.pagination = filterParams.paginationInfo;
        return initial;
    });

    React.useEffect(() => {
        if (props.visible && props.stop) {

            getAvailableOrders(props.stop.shipToAddressId);
        }
    }, [props.visible]);

    /**
     * Handler for when the user is done drag selecting items
     * @param evt The draggable event with selected items
     */
    const onDragComplete = (evt: any) => {

        // The select library we use calls dragComplete
        // whenever a component is unmounted.  However,
        // that causes issues.  Hacky, but it's what's 
        // required without changing implemenation.
        if (IGNORE_UNMOUNT_SELECTABLE) {
            return;
        }

        let tmpOrders = { ...availableOrders };

        tmpOrders.results.forEach((itm: OrderSummary) => {
            itm.isChecked = false;
        });

        for (let tmpOrder of tmpOrders.results) {
            for (let evtItem of evt) {
                if (tmpOrder.id === evtItem.props.orderItem.id) {
                    tmpOrder.isChecked = true;
                }
            }
        }

        setAvailableOrders(tmpOrders);
    };

    /**
     * Fetch the open orders for this address
     * @param id The ship-to address ID to fetch orders for
     */
    async function getAvailableOrders(id: number) {
        let tmpOrders = { ...availableOrders };
        tmpOrders.results = props.stop!.orders;
        setAvailableOrders(tmpOrders);
    }

    /**
     * Close handler for the flyout
     */
    const onClose = () => {
        props.onClose();
    };

    const onSave = async () => {

        var orderIds = availableOrders.results
            .filter(o => o.isChecked)
            .map(o => o.id);

        props.onSuccess(orderIds);
    };

    return <Drawer
        anchor="right"
        onClose={onClose}
        open={props.visible}>
        <div className="stop-action-drawer stop-action-add-backorder">
            <div className="row">
                <div className="col-md-12">
                    <h1>Backorder</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <PagedList
                        noResultsMessage="No available orders found for this stop."
                        searchCallback={() => { return; }}
                        data={availableOrders}
                        filterProps={filterParams}
                        hideFilterBar={true}
                        onFilterUpdate={() => { return; }}
                        skipScroll={true}
                        selectableClass="transport-order-selectable"
                        hidePager={true}
                        reduxDispatch={dispatch}
                        useClientSelectablePositioning={true}
                        enabledDrag={true}
                        onDragComplete={onDragComplete}
                        rowRenderer={(order: OrderSummary, extraProps: any) =>
                            <ShipmentActionAddOrderRow key={`stop-order-${order.id}`} orderItem={order} {...extraProps} />
                        }
                    />
                </div>
            </div>
            <FlyoutSaveCancel
                onSave={onSave}
                onCancel={props.onClose}
            />
        </div>
    </Drawer>;
}